var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicineDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#9EA9BA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8542 21.3592L19.9421 25.3447C20.8749 25.9807 22.0197 26.2775 23.122 26.1079C24.2668 25.9807 25.2844 25.3871 25.9627 24.4967L26.2171 24.1575C27.0227 23.0128 27.2771 21.5712 26.8107 20.2144C26.5139 19.4088 26.0475 18.6881 25.3268 18.1793L20.2389 14.1938L14.8542 21.3592Z",
    fill: "#0F0F0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04455 11.2678L8.79016 11.5646C7.94218 12.7093 7.73019 14.1933 8.19658 15.5501C8.45097 16.3556 8.95976 17.034 9.63814 17.5852L14.3444 21.1043L19.6443 13.9389L14.9804 10.4198C13.1148 8.97823 10.4013 9.35982 9.04455 11.2678Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicineDisabled);
export default __webpack_public_path__ + "static/media/MedicineDisabled.935923f726c8974913601e4c18e2cc46.svg";
export { ForwardRef as ReactComponent };